import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2333 2333"
      id="vector">
      <g
        id="group"
        transform="translate(182 72)">
        <path
          id="path"
          d="M 86.5 50 L 85.5 52 L 86.5 50 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 80.5 55 L 79.5 57 L 80.5 55 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 1160.5 56 L 1161.5 58 L 1160.5 56 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 71.5 63 L 63.5 72 L 71.5 63 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1183.5 79 L 1184.5 81 L 1183.5 79 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 55.5 80 L 54.5 82 L 55.5 80 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 1188.5 85 L 1189.5 87 L 1188.5 85 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 50.5 86 L 49.5 88 L 50.5 86 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 127.5 110 L 126.5 112 L 127.5 110 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1113.5 111 L 1115.5 114 L 1113.5 111 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 1127.5 125 L 1128.5 127 L 1127.5 125 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 110.5 127 L 109.5 129 L 110.5 127 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 898.5 228 L 899.5 230 L 898.5 228 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 901.5 231 L 902.5 233 L 901.5 231 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 1762.5 411 L 1759.5 415 L 1762.5 411 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1726.5 520 L 1722.5 525 L 1726.5 520 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 829.5 706 L 830.5 708 L 829.5 706 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1888.5 757 L 1887.5 759 L 1888.5 757 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 1831.5 758 L 1832.5 760 L 1831.5 758 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1883.5 763 L 1882.5 765 L 1883.5 763 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 1836.5 764 L 1837.5 766 L 1836.5 764 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1944.5 803 L 1943.5 805 L 1944.5 803 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1939.5 809 L 1938.5 811 L 1939.5 809 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1780.5 810 L 1781.5 812 L 1780.5 810 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 1932.5 817 L 1930.5 820 L 1932.5 817 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1788.5 819 L 1793.5 825 L 1788.5 819 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 1798.5 829 L 1799.5 831 L 1798.5 829 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1627.5 839 L 1628.5 841 L 1627.5 839 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 1432.5 842 L 1425.5 850 L 1432.5 842 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1639.5 851 L 1641.5 854 L 1639.5 851 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 1419.5 856 L 1418.5 858 L 1419.5 856 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 827.5 886 L 828.5 888 L 827.5 886 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1487.5 890 L 1486.5 892 L 1487.5 890 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1580.5 894 L 1585.5 900 L 1580.5 894 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 1480.5 896 L 1479.5 898 L 1480.5 896 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 627.5 934 L 628.5 936 L 627.5 934 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 574.5 998 L 575.5 1000 L 574.5 998 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 575.5 1299 L 574.5 1301 L 575.5 1299 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 1157.5 1512 L 1158.5 1514 L 1157.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 76.5 1517 L 75.5 1519 L 76.5 1517 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 1110.5 1567 L 1111.5 1569 L 1110.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 123.5 1572 L 121.5 1575 L 123.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1119.5 1575 L 1123.5 1580 L 1119.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 114.5 1581 L 112.5 1584 L 114.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1130.5 1587 L 1131.5 1589 L 1130.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 158.5 1614 L 154.5 1619 L 158.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 551.5 1629 L 550.5 1631 L 551.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 702.5 1643 L 703.5 1645 L 702.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 643.5 1686 L 644.5 1688 L 643.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 646.5 1689 L 647.5 1691 L 646.5 1689 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 591.5 1691 L 590.5 1693 L 591.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 1696.5 1691 L 1700.5 1696 L 1696.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 1797.5 1697 L 1796.5 1699 L 1797.5 1697 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 1635.5 1731 L 1636.5 1733 L 1635.5 1731 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 1862.5 1734 L 1861.5 1736 L 1862.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 1640.5 1737 L 1641.5 1739 L 1640.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1653.5 1750 L 1654.5 1752 L 1653.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 1659.5 1755 L 1660.5 1757 L 1659.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 539.5 1788 L 546.5 1796 L 539.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 105.5 1837 L 106.5 1839 L 105.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 110.5 1843 L 111.5 1845 L 110.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1129.5 1843 L 1128.5 1845 L 1129.5 1843 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 125.5 1858 L 126.5 1860 L 125.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1114.5 1858 L 1113.5 1860 L 1114.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 131.5 1863 L 132.5 1865 L 131.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 1108.5 1863 L 1107.5 1865 L 1108.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1190.5 1883 L 1189.5 1885 L 1190.5 1883 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1185.5 1889 L 1184.5 1891 L 1185.5 1889 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 55.5 1890 L 56.5 1892 L 55.5 1890 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 1177.5 1898 L 1168.5 1908 L 1177.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 78.5 1913 L 79.5 1915 L 78.5 1913 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1160.5 1914 L 1159.5 1916 L 1160.5 1914 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 1154.5 1919 L 1153.5 1921 L 1154.5 1919 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 1075.5 1981 L 1069.5 1988 L 1075.5 1981 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 821.5 1982 L 825.5 1987 L 821.5 1982 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 1016.5 2061 L 1017.5 2063 L 1016.5 2061 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1348.5 2067 L 1346.5 2070 L 1348.5 2067 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 1022.5 2068 L 1031.5 2078 L 1022.5 2068 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1339.5 2076 L 1337.5 2079 L 1339.5 2076 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 1037.5 2082 L 1038.5 2084 L 1037.5 2082 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 961.5 2108 L 962.5 2110 L 961.5 2108 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 1403.5 2114 L 1402.5 2116 L 1403.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 967.5 2115 L 969.5 2118 L 967.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 982.5 2130 L 984.5 2133 L 982.5 2130 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 1385.5 2132 L 1384.5 2134 L 1385.5 2132 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1378.5 2138 L 1377.5 2140 L 1378.5 2138 Z"
          fill="currentColor"
          fillOpacity="0.9137255"
          stroke="currentColor"
          strokeOpacity="0.9137255"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 223.5 0 L 1017 0.5 L 223.5 1 L 223.5 0 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 206.5 1 L 212 1.5 L 206.5 2 L 206.5 1 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 1028.5 1 L 1034 1.5 L 1028.5 2 L 1028.5 1 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 198.5 2 L 201 2.5 L 198.5 3 L 198.5 2 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1039.5 2 L 1042 2.5 L 1039.5 3 L 1039.5 2 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 191.5 3 L 194 3.5 L 191.5 4 L 191.5 3 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1046.5 3 L 1049 3.5 L 1046.5 4 L 1046.5 3 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 185.5 4 L 188 4.5 L 185.5 5 L 185.5 4 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 103.5 37 L 102.5 39 L 103.5 37 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 100.5 39 L 99.5 41 L 100.5 39 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 97.5 41 L 96.5 43 L 97.5 41 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1146.5 44 L 1147.5 46 L 1146.5 44 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 89.5 47 L 88.5 49 L 89.5 47 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 1150.5 47 L 1151.5 49 L 1150.5 47 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 85.5 50 L 84.5 52 L 85.5 50 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1155.5 51 L 1156.5 53 L 1155.5 51 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 79.5 55 L 77.5 58 L 79.5 55 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1161.5 56 L 1164.5 60 L 1161.5 56 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 70.5 63 L 62.5 72 L 70.5 63 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 215.5 74 L 222 74.5 L 215.5 75 L 215.5 74 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1018.5 74 L 1025 74.5 L 1018.5 75 L 1018.5 74 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 206.5 75 L 209 75.5 L 206.5 76 L 206.5 75 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 1030.5 75 L 1034 75.5 L 1030.5 76 L 1030.5 75 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 1037.5 76 L 1040 76.5 L 1037.5 77 L 1037.5 76 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1181.5 76 L 1184.5 80 L 1181.5 76 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 56.5 78 L 54.5 81 L 56.5 78 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 1187.5 83 L 1189.5 86 L 1187.5 83 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 51.5 84 L 49.5 87 L 51.5 84 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 1191.5 88 L 1192.5 90 L 1191.5 88 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 47.5 89 L 46.5 91 L 47.5 89 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 44.5 93 L 43.5 95 L 44.5 93 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1197.5 96 L 1198.5 98 L 1197.5 96 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 144.5 98 L 143.5 100 L 144.5 98 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 39.5 100 L 38.5 102 L 39.5 100 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 141.5 100 L 140.5 102 L 141.5 100 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 37.5 103 L 36.5 105 L 37.5 103 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1102.5 103 L 1103.5 105 L 1102.5 103 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 134.5 105 L 133.5 107 L 134.5 105 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1106.5 106 L 1107.5 108 L 1106.5 106 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 129.5 109 L 127.5 112 L 129.5 109 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 1111.5 110 L 1114.5 114 L 1111.5 110 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 121.5 116 L 115.5 123 L 121.5 116 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 1127.5 126 L 1129.5 129 L 1127.5 126 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 110.5 128 L 108.5 131 L 110.5 128 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1132.5 132 L 1134.5 135 L 1132.5 132 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 105.5 134 L 104.5 136 L 105.5 134 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 1138.5 140 L 1139.5 142 L 1138.5 140 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 100.5 141 L 99.5 143 L 100.5 141 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 98.5 144 L 97.5 146 L 98.5 144 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 1142.5 146 L 1143.5 148 L 1142.5 146 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 1237.5 194 L 1238 196.5 L 1237 196.5 L 1237.5 194 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1.5 199 L 2 202.5 L 1 202.5 L 1.5 199 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 75.5 201 L 76 203.5 L 75 203.5 L 75.5 201 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1238.5 201 L 1239 204.5 L 1238 204.5 L 1238.5 201 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 1164.5 203 L 1165 205.5 L 1164 205.5 L 1164.5 203 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 0.5 208 L 1 213.5 L 0 213.5 L 0.5 208 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 74.5 208 L 75 210.5 L 74 210.5 L 74.5 208 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1165.5 210 L 1166 212.5 L 1165 212.5 L 1165.5 210 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1239.5 211 L 1240 217.5 L 1239 217.5 L 1239.5 211 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 73.5 216 L 74 224.5 L 73 224.5 L 73.5 216 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 323.5 219 L 880 219.5 L 323.5 220 L 323.5 219 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1166.5 220 L 1167 1519.5 L 1166 1519.5 L 1166.5 220 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 899.5 228 L 903.5 233 L 899.5 228 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 911.5 250 L 912 252.5 L 911 252.5 L 911.5 250 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 291.5 252 L 292 515.5 L 291 515.5 L 291.5 252 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 838.5 293 L 839 473.5 L 837.5 475 L 365.5 475 L 365.5 474 L 838 474 L 838.5 293 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 474.5 329 L 475 437.5 L 473.5 439 L 401.5 439 L 401.5 438 L 474 438 L 474.5 329 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 583.5 329 L 584 439 L 510 438.5 L 583 438 L 583.5 329 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 619.5 329 L 620 438 L 693 438.5 L 620.5 439 L 619 437.5 L 619.5 329 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1955.5 409 L 1961.5 416 L 1955.5 409 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1761.5 411 L 1759.5 414 L 1761.5 411 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 1969.5 438 L 1970 510.5 L 1969 510.5 L 1969.5 438 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 1823.5 475 L 1824 510.5 L 1823 510.5 L 1823.5 475 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 1744.5 511 L 1747 511.5 L 1744.5 512 L 1744.5 511 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 1972.5 511 L 1976 511.5 L 1972.5 512 L 1972.5 511 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 911.5 514 L 912 517.5 L 911 517.5 L 911.5 514 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 1988.5 516 L 1989.5 518 L 1988.5 516 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1992.5 519 L 1997.5 525 L 1992.5 519 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 1725.5 520 L 1722.5 524 L 1725.5 520 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 299.5 534 L 300.5 536 L 299.5 534 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 303.5 538 L 305.5 541 L 303.5 538 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 897.5 540 L 896.5 542 L 897.5 540 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 2005.5 542 L 2006 645.5 L 2005 645.5 L 2005.5 542 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 1713.5 544 L 1714 640.5 L 1713 640.5 L 1713.5 544 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 320.5 547 L 323 547.5 L 320.5 548 L 320.5 547 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 1787.5 584 L 1931.5 584 L 1933 585.5 L 1932.5 632 L 1932 585 L 1787.5 585 L 1787.5 584 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 1787.5 641 L 1788 646.5 L 1787 646.5 L 1787.5 641 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 1931.5 644 L 1932 648.5 L 1931 648.5 L 1931.5 644 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 1714.5 650 L 1715 655.5 L 1714 655.5 L 1714.5 650 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 1788.5 653 L 1789 655.5 L 1788 655.5 L 1788.5 653 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 2004.5 653 L 2005 657.5 L 2004 657.5 L 2004.5 653 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 1930.5 654 L 1931 657.5 L 1930 657.5 L 1930.5 654 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 1789.5 660 L 1790 662.5 L 1789 662.5 L 1789.5 660 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 1715.5 661 L 1716 664.5 L 1715 664.5 L 1715.5 661 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 2003.5 663 L 2004 666.5 L 2003 666.5 L 2003.5 663 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1790.5 666 L 1791 668.5 L 1790 668.5 L 1790.5 666 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 1928.5 667 L 1929 669.5 L 1928 669.5 L 1928.5 667 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 1716.5 669 L 1717 671.5 L 1716 671.5 L 1716.5 669 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 506.5 693 L 807 693.5 L 506.5 694 L 506.5 693 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 488.5 700 L 486.5 703 L 488.5 700 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 825.5 701 L 830.5 707 L 825.5 701 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 482.5 706 L 481.5 708 L 482.5 706 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 838.5 723 L 839 725.5 L 838 725.5 L 838.5 723 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 838.5 734 L 839 736.5 L 838 736.5 L 838.5 734 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 1894.5 748 L 1893.5 750 L 1894.5 748 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 831.5 752 L 830.5 754 L 831.5 752 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1888.5 756 L 1887.5 758 L 1888.5 756 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 827.5 757 L 826.5 759 L 827.5 757 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 1831.5 757 L 1832.5 759 L 1831.5 757 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 1884.5 761 L 1882.5 764 L 1884.5 761 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 823.5 762 L 822.5 764 L 823.5 762 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 1835.5 762 L 1837.5 765 L 1835.5 762 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 1839.5 766 L 1880 766.5 L 1839.5 767 L 1839.5 766 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 819.5 767 L 818.5 769 L 819.5 767 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 724.5 768 L 723.5 770 L 724.5 768 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 815.5 772 L 814.5 774 L 815.5 772 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 720.5 773 L 719.5 775 L 720.5 773 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 811.5 777 L 810.5 779 L 811.5 777 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 716.5 778 L 715.5 780 L 716.5 778 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 1757.5 780 L 1758.5 782 L 1757.5 780 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 807.5 782 L 806.5 784 L 807.5 782 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 712.5 783 L 711.5 785 L 712.5 783 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1761.5 786 L 1762.5 788 L 1761.5 786 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 803.5 787 L 802.5 789 L 803.5 787 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 708.5 788 L 707.5 790 L 708.5 788 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1763.5 789 L 1764.5 791 L 1763.5 789 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 799.5 792 L 798.5 794 L 799.5 792 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1953.5 792 L 1952.5 794 L 1953.5 792 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 704.5 793 L 703.5 795 L 704.5 793 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 795.5 797 L 794.5 799 L 795.5 797 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 700.5 798 L 699.5 800 L 700.5 798 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 1947.5 800 L 1946.5 802 L 1947.5 800 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1772.5 801 L 1773.5 803 L 1772.5 801 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 791.5 802 L 790.5 804 L 791.5 802 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 696.5 803 L 695.5 805 L 696.5 803 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 1516.5 803 L 1521 803.5 L 1516.5 804 L 1516.5 803 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 1543.5 803 L 1548 803.5 L 1543.5 804 L 1543.5 803 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1552.5 804 L 1555 804.5 L 1552.5 805 L 1552.5 804 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1944.5 804 L 1942.5 807 L 1944.5 804 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1775.5 805 L 1777.5 808 L 1775.5 805 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 787.5 807 L 786.5 809 L 787.5 807 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 692.5 808 L 691.5 810 L 692.5 808 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1939.5 810 L 1937.5 813 L 1939.5 810 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 1780.5 811 L 1783.5 815 L 1780.5 811 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 783.5 812 L 782.5 814 L 783.5 812 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 688.5 813 L 687.5 815 L 688.5 813 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 779.5 817 L 778.5 819 L 779.5 817 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 1933.5 817 L 1919.5 832 L 1933.5 817 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 684.5 818 L 683.5 820 L 684.5 818 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1788.5 820 L 1799.5 832 L 1788.5 820 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 775.5 822 L 774.5 824 L 775.5 822 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 680.5 823 L 679.5 825 L 680.5 823 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 1453.5 825 L 1452.5 827 L 1453.5 825 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1611.5 826 L 1612.5 828 L 1611.5 826 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 771.5 827 L 770.5 829 L 771.5 827 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 676.5 828 L 675.5 830 L 676.5 828 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 1614.5 828 L 1615.5 830 L 1614.5 828 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 1447.5 829 L 1446.5 831 L 1447.5 829 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 767.5 832 L 766.5 834 L 767.5 832 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 1443.5 832 L 1442.5 834 L 1443.5 832 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 672.5 833 L 671.5 835 L 672.5 833 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 1916.5 833 L 1915.5 835 L 1916.5 833 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 1622.5 834 L 1623.5 836 L 1622.5 834 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 1439.5 835 L 1437.5 838 L 1439.5 835 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 763.5 837 L 762.5 839 L 763.5 837 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 668.5 838 L 667.5 840 L 668.5 838 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1628.5 839 L 1632.5 844 L 1628.5 839 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 1817.5 839 L 1821 839.5 L 1817.5 840 L 1817.5 839 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 1899.5 839 L 1902 839.5 L 1899.5 840 L 1899.5 839 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 1896.5 840 L 1897 1645.5 L 1896 1645.5 L 1896.5 840 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 759.5 842 L 758.5 844 L 759.5 842 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1431.5 842 L 1424.5 850 L 1431.5 842 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 664.5 843 L 663.5 845 L 664.5 843 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 755.5 847 L 754.5 849 L 755.5 847 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 1636.5 847 L 1641.5 853 L 1636.5 847 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 660.5 848 L 659.5 850 L 660.5 848 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 751.5 852 L 750.5 854 L 751.5 852 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 656.5 853 L 655.5 855 L 656.5 853 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 1420.5 854 L 1418.5 857 L 1420.5 854 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 1644.5 856 L 1646.5 859 L 1644.5 856 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 747.5 857 L 746.5 859 L 747.5 857 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 652.5 858 L 651.5 860 L 652.5 858 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 1415.5 860 L 1414.5 862 L 1415.5 860 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 1648.5 861 L 1649.5 863 L 1648.5 861 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 743.5 862 L 742.5 864 L 743.5 862 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 648.5 863 L 647.5 865 L 648.5 863 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 739.5 867 L 738.5 869 L 739.5 867 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 644.5 868 L 643.5 870 L 644.5 868 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 735.5 872 L 734.5 874 L 735.5 872 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 640.5 873 L 639.5 875 L 640.5 873 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 1524.5 876 L 1539 876.5 L 1524.5 877 L 1524.5 876 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 1543.5 877 L 1546 877.5 L 1543.5 878 L 1543.5 877 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 636.5 878 L 635.5 880 L 636.5 878 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 632.5 883 L 631.5 885 L 632.5 883 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1570.5 887 L 1571.5 889 L 1570.5 887 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 628.5 888 L 627.5 890 L 628.5 888 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 831.5 890 L 832.5 892 L 831.5 890 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 1488.5 890 L 1487.5 892 L 1488.5 890 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 1578.5 893 L 1586.5 902 L 1578.5 893 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1483.5 894 L 1476.5 902 L 1483.5 894 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1589.5 905 L 1590.5 907 L 1589.5 905 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 1471.5 908 L 1470.5 910 L 1471.5 908 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 619.5 910 L 620 914.5 L 619 914.5 L 619.5 910 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 838.5 916 L 839 918.5 L 838 918.5 L 838.5 916 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 1387.5 923 L 1388 925.5 L 1387 925.5 L 1387.5 923 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 1675.5 923 L 1676 925.5 L 1675 925.5 L 1675.5 923 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 1676.5 929 L 1677 932.5 L 1676 932.5 L 1676.5 929 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 1386.5 930 L 1387 932.5 L 1386 932.5 L 1386.5 930 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 832.5 933 L 831.5 935 L 832.5 933 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 627.5 935 L 633.5 942 L 627.5 935 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 830.5 936 L 829.5 938 L 830.5 936 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 1459.5 938 L 1460 940.5 L 1459 940.5 L 1459.5 938 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1603.5 938 L 1604 941.5 L 1603 941.5 L 1603.5 938 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 1385.5 939 L 1386 1974.5 L 1385 1974.5 L 1385.5 939 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 1677.5 940 L 1678 1646.5 L 1677 1646.5 L 1677.5 940 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 825.5 943 L 824.5 945 L 825.5 943 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 823.5 946 L 822.5 948 L 823.5 946 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 731.5 949 L 730.5 951 L 731.5 949 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 729.5 952 L 728.5 954 L 729.5 952 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 818.5 953 L 817.5 955 L 818.5 953 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 816.5 956 L 815.5 958 L 816.5 956 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 724.5 959 L 723.5 961 L 724.5 959 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 722.5 962 L 721.5 964 L 722.5 962 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 811.5 963 L 810.5 965 L 811.5 963 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 809.5 966 L 808.5 968 L 809.5 966 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 717.5 969 L 716.5 971 L 717.5 969 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 715.5 972 L 714.5 974 L 715.5 972 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 804.5 973 L 803.5 975 L 804.5 973 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 802.5 976 L 801.5 978 L 802.5 976 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 710.5 979 L 709.5 981 L 710.5 979 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 708.5 982 L 707.5 984 L 708.5 982 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 797.5 983 L 796.5 985 L 797.5 983 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 550.5 985 L 554 985.5 L 550.5 986 L 550.5 985 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 795.5 986 L 794.5 988 L 795.5 986 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 703.5 989 L 702.5 991 L 703.5 989 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 701.5 992 L 700.5 994 L 701.5 992 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 570.5 993 L 575.5 999 L 570.5 993 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 790.5 993 L 789.5 995 L 790.5 993 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 788.5 996 L 787.5 998 L 788.5 996 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 696.5 999 L 695.5 1001 L 696.5 999 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 694.5 1002 L 693.5 1004 L 694.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 783.5 1003 L 782.5 1005 L 783.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 781.5 1006 L 780.5 1008 L 781.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 689.5 1009 L 688.5 1011 L 689.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 687.5 1012 L 686.5 1014 L 687.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 776.5 1013 L 775.5 1015 L 776.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 583.5 1016 L 584 1158.5 L 585 1159.5 L 583 1160 L 583.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 774.5 1016 L 773.5 1018 L 774.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 682.5 1019 L 681.5 1021 L 682.5 1019 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 680.5 1022 L 679.5 1024 L 680.5 1022 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 769.5 1023 L 768.5 1025 L 769.5 1023 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 767.5 1026 L 766.5 1028 L 767.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 675.5 1029 L 674.5 1031 L 675.5 1029 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 673.5 1032 L 672.5 1034 L 673.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 762.5 1033 L 761.5 1035 L 762.5 1033 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 760.5 1036 L 759.5 1038 L 760.5 1036 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 668.5 1039 L 667.5 1041 L 668.5 1039 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 666.5 1042 L 665.5 1044 L 666.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 755.5 1043 L 754.5 1045 L 755.5 1043 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 408.5 1044 L 409.5 1046 L 408.5 1044 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 753.5 1046 L 752.5 1048 L 753.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 413.5 1049 L 415.5 1052 L 413.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 661.5 1049 L 660.5 1051 L 661.5 1049 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 659.5 1052 L 658.5 1054 L 659.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 748.5 1053 L 747.5 1055 L 748.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 746.5 1056 L 745.5 1058 L 746.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 433.5 1058 L 509.5 1058 L 511 1059.5 L 510.5 1283 L 510 1059 L 433.5 1059 L 433.5 1058 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 654.5 1059 L 653.5 1061 L 654.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 652.5 1062 L 651.5 1064 L 652.5 1062 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 741.5 1063 L 740.5 1065 L 741.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 739.5 1066 L 738.5 1068 L 739.5 1066 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 647.5 1069 L 646.5 1071 L 647.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 645.5 1072 L 644.5 1074 L 645.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 734.5 1073 L 733.5 1075 L 734.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 732.5 1076 L 731.5 1078 L 732.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 640.5 1079 L 639.5 1081 L 640.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 638.5 1082 L 637.5 1084 L 638.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 727.5 1083 L 726.5 1085 L 727.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 725.5 1086 L 724.5 1088 L 725.5 1086 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 633.5 1089 L 632.5 1091 L 633.5 1089 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 631.5 1092 L 630.5 1094 L 631.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 720.5 1093 L 719.5 1095 L 720.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 718.5 1096 L 717.5 1098 L 718.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 626.5 1099 L 625.5 1101 L 626.5 1099 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 624.5 1102 L 623.5 1104 L 624.5 1102 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 713.5 1103 L 712.5 1105 L 713.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 711.5 1106 L 710.5 1108 L 711.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 619.5 1109 L 618.5 1111 L 619.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 617.5 1112 L 616.5 1114 L 617.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 706.5 1113 L 705.5 1115 L 706.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 704.5 1116 L 703.5 1118 L 704.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 612.5 1119 L 611.5 1121 L 612.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 610.5 1122 L 609.5 1124 L 610.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 699.5 1123 L 698.5 1125 L 699.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 697.5 1126 L 696.5 1128 L 697.5 1126 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 605.5 1129 L 604.5 1131 L 605.5 1129 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 603.5 1132 L 602.5 1134 L 603.5 1132 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 692.5 1133 L 691.5 1135 L 692.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 690.5 1136 L 689.5 1138 L 690.5 1136 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 598.5 1139 L 597.5 1141 L 598.5 1139 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 596.5 1142 L 595.5 1144 L 596.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 685.5 1143 L 684.5 1145 L 685.5 1143 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 683.5 1146 L 682.5 1148 L 683.5 1146 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 591.5 1149 L 590.5 1151 L 591.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 589.5 1152 L 588.5 1154 L 589.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 678.5 1153 L 677.5 1155 L 678.5 1153 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 676.5 1156 L 675.5 1158 L 676.5 1156 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 671.5 1163 L 670.5 1165 L 671.5 1163 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 669.5 1166 L 668.5 1168 L 669.5 1166 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 664.5 1173 L 663.5 1175 L 664.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 662.5 1176 L 661.5 1178 L 662.5 1176 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 657.5 1183 L 656.5 1185 L 657.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 655.5 1186 L 654.5 1188 L 655.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 650.5 1193 L 649.5 1195 L 650.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 648.5 1196 L 647.5 1198 L 648.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 643.5 1203 L 642.5 1205 L 643.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 641.5 1206 L 640.5 1208 L 641.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 636.5 1213 L 635.5 1215 L 636.5 1213 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 634.5 1216 L 633.5 1218 L 634.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 629.5 1223 L 628.5 1225 L 629.5 1223 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 627.5 1226 L 626.5 1228 L 627.5 1226 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 622.5 1233 L 621.5 1235 L 622.5 1233 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 620.5 1236 L 619.5 1238 L 620.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 615.5 1243 L 614.5 1245 L 615.5 1243 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 613.5 1246 L 612.5 1248 L 613.5 1246 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 608.5 1253 L 607.5 1255 L 608.5 1253 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 606.5 1256 L 605.5 1258 L 606.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 601.5 1263 L 600.5 1265 L 601.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 599.5 1266 L 598.5 1268 L 599.5 1266 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 594.5 1273 L 593.5 1275 L 594.5 1273 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 592.5 1276 L 591.5 1278 L 592.5 1276 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 587.5 1283 L 586.5 1285 L 587.5 1283 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 585.5 1286 L 584.5 1288 L 585.5 1286 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 580.5 1293 L 579.5 1295 L 580.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 578.5 1296 L 577.5 1298 L 578.5 1296 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 518.5 1300 L 523.5 1306 L 518.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 575.5 1300 L 570.5 1306 L 575.5 1300 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 526.5 1307 L 527.5 1309 L 526.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 541.5 1313 L 544 1313.5 L 541.5 1314 L 541.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 550.5 1313 L 553 1313.5 L 550.5 1314 L 550.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 212.5 1459 L 221 1459.5 L 212.5 1460 L 212.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 1018.5 1459 L 1028 1459.5 L 1018.5 1460 L 1018.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 201.5 1460 L 205 1460.5 L 201.5 1461 L 201.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 1035.5 1460 L 1039 1460.5 L 1035.5 1461 L 1035.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 194.5 1461 L 197 1461.5 L 194.5 1462 L 194.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1043.5 1461 L 1046 1461.5 L 1043.5 1462 L 1043.5 1461 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1141.5 1499 L 1142.5 1501 L 1141.5 1499 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 1148.5 1504 L 1149.5 1506 L 1148.5 1504 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 87.5 1507 L 86.5 1509 L 87.5 1507 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 1153.5 1508 L 1154.5 1510 L 1153.5 1508 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 82.5 1511 L 81.5 1513 L 82.5 1511 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1158.5 1512 L 1160.5 1515 L 1158.5 1512 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 76.5 1516 L 73.5 1520 L 76.5 1516 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 222.5 1532 L 1018 1532.5 L 222.5 1533 L 222.5 1532 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 210.5 1533 L 214 1533.5 L 210.5 1534 L 210.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 1026.5 1533 L 1030 1533.5 L 1026.5 1534 L 1026.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 203.5 1534 L 206 1534.5 L 203.5 1535 L 203.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 1034.5 1534 L 1037 1534.5 L 1034.5 1535 L 1034.5 1534 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1094.5 1556 L 1095.5 1558 L 1094.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 1097.5 1558 L 1098.5 1560 L 1097.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 1100.5 1560 L 1101.5 1562 L 1100.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 136.5 1562 L 135.5 1564 L 136.5 1562 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1104.5 1563 L 1105.5 1565 L 1104.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 132.5 1565 L 130.5 1568 L 132.5 1565 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 1108.5 1566 L 1110.5 1569 L 1108.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 126.5 1570 L 122.5 1575 L 126.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 1115.5 1572 L 1126.5 1584 L 1115.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 115.5 1581 L 111.5 1586 L 115.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1130.5 1588 L 1132.5 1591 L 1130.5 1588 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 107.5 1590 L 106.5 1592 L 107.5 1590 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1134.5 1593 L 1135.5 1595 L 1134.5 1593 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 104.5 1594 L 103.5 1596 L 104.5 1594 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1137.5 1597 L 1138.5 1599 L 1137.5 1597 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 101.5 1598 L 100.5 1600 L 101.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 99.5 1601 L 98.5 1603 L 99.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 175.5 1605 L 178 1605.5 L 175.5 1606 L 175.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 607.5 1605 L 612 1605.5 L 607.5 1606 L 607.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 627.5 1605 L 632 1605.5 L 627.5 1606 L 627.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 831.5 1605 L 834 1605.5 L 831.5 1606 L 831.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1062.5 1605 L 1065 1605.5 L 1062.5 1606 L 1062.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 817.5 1611 L 816.5 1613 L 817.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 1078.5 1611 L 1079.5 1613 L 1078.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 423.5 1612 L 424.5 1614 L 423.5 1612 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 158.5 1613 L 154.5 1618 L 158.5 1613 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 429.5 1618 L 430.5 1620 L 429.5 1618 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 809.5 1619 L 808.5 1621 L 809.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 1086.5 1619 L 1087.5 1621 L 1086.5 1619 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 682.5 1624 L 683.5 1626 L 682.5 1624 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 554.5 1626 L 553.5 1628 L 554.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 550.5 1629 L 548.5 1632 L 550.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 690.5 1630 L 693.5 1634 L 690.5 1630 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 437.5 1635 L 438 1638.5 L 437 1638.5 L 437.5 1635 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 145.5 1639 L 146 1790.5 L 145 1790.5 L 145.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 701.5 1641 L 703.5 1644 L 701.5 1641 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 536.5 1643 L 534.5 1646 L 536.5 1643 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1822.5 1646 L 1823 1650.5 L 1822 1650.5 L 1822.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 706.5 1647 L 707.5 1649 L 706.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 532.5 1648 L 531.5 1650 L 532.5 1648 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1604.5 1648 L 1605 1654.5 L 1604 1654.5 L 1604.5 1648 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1895.5 1655 L 1896 1658.5 L 1895 1658.5 L 1895.5 1655 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 1605.5 1660 L 1606 1662.5 L 1605 1662.5 L 1605.5 1660 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 1164.5 1661 L 1165 1663.5 L 1164 1663.5 L 1164.5 1661 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 74.5 1666 L 75 1668.5 L 74 1668.5 L 74.5 1666 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1165.5 1668 L 1166 1671.5 L 1165 1671.5 L 1165.5 1668 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 73.5 1675 L 74 1682.5 L 73 1682.5 L 73.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 219.5 1678 L 363.5 1678 L 365 1679.5 L 364.5 1751 L 364 1679 L 219.5 1679 L 219.5 1678 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 616.5 1678 L 624 1678.5 L 616.5 1679 L 616.5 1678 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 875 1678 L 1021 1678 L 1021 1932.5 L 1020 1932.5 L 1020 1679 L 876 1679 L 875.5 1933 L 875 1678 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1166.5 1679 L 1167 1750.5 L 1166 1750.5 L 1166.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1810.5 1682 L 1809.5 1684 L 1810.5 1682 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 638.5 1683 L 639.5 1685 L 638.5 1683 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 1691.5 1684 L 1692.5 1686 L 1691.5 1684 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 598.5 1685 L 597.5 1687 L 598.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 641.5 1685 L 643.5 1688 L 641.5 1685 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1807.5 1686 L 1806.5 1688 L 1807.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1694.5 1688 L 1703.5 1698 L 1694.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 646.5 1690 L 648.5 1693 L 646.5 1690 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 591.5 1692 L 590.5 1694 L 591.5 1692 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 1796.5 1697 L 1795.5 1699 L 1796.5 1697 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 728.5 1698 L 729 1700.5 L 728 1700.5 L 728.5 1698 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 1706.5 1699 L 1707.5 1701 L 1706.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 510.5 1704 L 511 1712.5 L 510 1712.5 L 510.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 655.5 1707 L 656 1709.5 L 655 1709.5 L 655.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 729.5 1707 L 730 1721.5 L 729 1721.5 L 729.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 583.5 1713 L 584 1716.5 L 583 1716.5 L 583.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1760.5 1713 L 1763 1713.5 L 1760.5 1714 L 1760.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1746.5 1714 L 1755 1714.5 L 1746.5 1715 L 1746.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 510.5 1717 L 511 1724.5 L 510 1724.5 L 510.5 1717 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 1873.5 1720 L 1872.5 1722 L 1873.5 1720 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1871.5 1723 L 1870.5 1725 L 1871.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1869.5 1726 L 1868.5 1728 L 1869.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 728.5 1728 L 729 1730.5 L 728 1730.5 L 728.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1632.5 1728 L 1633.5 1730 L 1632.5 1728 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 511.5 1730 L 512 1732.5 L 511 1732.5 L 511.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 1866.5 1730 L 1865.5 1732 L 1866.5 1730 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1635.5 1732 L 1636.5 1734 L 1635.5 1732 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 589.5 1734 L 590.5 1736 L 589.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 649.5 1735 L 648.5 1737 L 649.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 1862.5 1735 L 1860.5 1738 L 1862.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1640.5 1738 L 1644.5 1743 L 1640.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 593.5 1739 L 595.5 1742 L 593.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 641.5 1743 L 640.5 1745 L 641.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 73.5 1747 L 74 1754.5 L 73 1754.5 L 73.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1649.5 1747 L 1653.5 1752 L 1649.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 614.5 1750 L 617 1750.5 L 614.5 1751 L 614.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 623.5 1750 L 626 1750.5 L 623.5 1751 L 623.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 1845.5 1752 L 1843.5 1755 L 1845.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1239.5 1754 L 1240 1760.5 L 1239 1760.5 L 1239.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 1658.5 1755 L 1659.5 1757 L 1658.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 1840.5 1756 L 1839.5 1758 L 1840.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 0.5 1757 L 1 1762.5 L 0 1762.5 L 0.5 1757 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 1165.5 1758 L 1166 1761.5 L 1165 1761.5 L 1165.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 1662.5 1758 L 1663.5 1760 L 1662.5 1758 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 74.5 1760 L 75 1762.5 L 74 1762.5 L 74.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 75.5 1767 L 76 1769.5 L 75 1769.5 L 75.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 1238.5 1767 L 1239 1770.5 L 1238 1770.5 L 1238.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 1.5 1768 L 2 1771.5 L 1 1771.5 L 1.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 528.5 1775 L 529.5 1777 L 528.5 1775 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 1237.5 1775 L 1238 1777.5 L 1237 1777.5 L 1237.5 1775 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 530.5 1778 L 531.5 1780 L 530.5 1778 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 708.5 1779 L 707.5 1781 L 708.5 1779 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 1236.5 1781 L 1237 1783.5 L 1236 1783.5 L 1236.5 1781 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 533.5 1782 L 535.5 1785 L 533.5 1782 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 705.5 1783 L 703.5 1786 L 705.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 1775.5 1785 L 1778 1785.5 L 1775.5 1786 L 1775.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 1729.5 1786 L 1732 1786.5 L 1729.5 1787 L 1729.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 1768.5 1786 L 1772 1786.5 L 1768.5 1787 L 1768.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1737.5 1787 L 1745 1787.5 L 1737.5 1788 L 1737.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 1756.5 1787 L 1763 1787.5 L 1756.5 1788 L 1756.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 539.5 1789 L 545.5 1796 L 539.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 437.5 1790 L 438 1793.5 L 437 1793.5 L 437.5 1790 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 690.5 1798 L 688.5 1801 L 690.5 1798 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 550.5 1799 L 551.5 1801 L 550.5 1799 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 554.5 1802 L 555.5 1804 L 554.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 685.5 1802 L 684.5 1804 L 685.5 1802 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 431.5 1808 L 430.5 1810 L 431.5 1808 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 153.5 1810 L 154.5 1812 L 153.5 1810 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 158.5 1815 L 159.5 1817 L 158.5 1815 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 605.5 1823 L 609 1823.5 L 605.5 1824 L 605.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 631.5 1823 L 635 1823.5 L 631.5 1824 L 631.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 180.5 1824 L 403 1824.5 L 180.5 1825 L 180.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 617.5 1824 L 623 1824.5 L 617.5 1825 L 617.5 1824 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 102.5 1832 L 103.5 1834 L 102.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 1137.5 1832 L 1136.5 1834 L 1137.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 105.5 1836 L 106.5 1838 L 105.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1134.5 1836 L 1133.5 1838 L 1134.5 1836 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 109.5 1841 L 111.5 1844 L 109.5 1841 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 1130.5 1841 L 1128.5 1844 L 1130.5 1841 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 126.5 1858 L 128.5 1861 L 126.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 1113.5 1858 L 1111.5 1861 L 1113.5 1858 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 132.5 1863 L 133.5 1865 L 132.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 1107.5 1863 L 1106.5 1865 L 1107.5 1863 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 136.5 1866 L 137.5 1868 L 136.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 1103.5 1866 L 1102.5 1868 L 1103.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 1203.5 1866 L 1202.5 1868 L 1203.5 1866 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 1201.5 1869 L 1200.5 1871 L 1201.5 1869 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 1199.5 1872 L 1198.5 1874 L 1199.5 1872 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 43.5 1876 L 44.5 1878 L 43.5 1876 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 46.5 1880 L 47.5 1882 L 46.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 1193.5 1880 L 1192.5 1882 L 1193.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1190.5 1884 L 1189.5 1886 L 1190.5 1884 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 50.5 1885 L 51.5 1887 L 50.5 1885 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 1185.5 1890 L 1183.5 1893 L 1185.5 1890 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 55.5 1891 L 58.5 1895 L 55.5 1891 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 207.5 1895 L 211 1895.5 L 207.5 1896 L 207.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 216.5 1896 L 802 1896.5 L 216.5 1897 L 216.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 1177.5 1899 L 1169.5 1908 L 1177.5 1899 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 75.5 1911 L 78.5 1915 L 75.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 1162.5 1913 L 1160.5 1916 L 1162.5 1913 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 83.5 1918 L 84.5 1920 L 83.5 1918 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 1155.5 1919 L 1154.5 1921 L 1155.5 1919 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 88.5 1922 L 89.5 1924 L 88.5 1922 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 1151.5 1922 L 1150.5 1924 L 1151.5 1922 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 92.5 1925 L 93.5 1927 L 92.5 1925 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 1147.5 1925 L 1146.5 1927 L 1147.5 1925 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 1140.5 1930 L 1139.5 1932 L 1140.5 1930 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 1137.5 1932 L 1136.5 1934 L 1137.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 192.5 1967 L 195 1967.5 L 192.5 1968 L 192.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 199.5 1968 L 203 1968.5 L 199.5 1969 L 199.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 208.5 1969 L 214 1969.5 L 208.5 1970 L 208.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1458.5 1973 L 1459 1984.5 L 1458 1984.5 L 1458.5 1973 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 816.5 1977 L 817.5 1979 L 816.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 1079.5 1977 L 1078.5 1979 L 1079.5 1977 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1075.5 1982 L 1070.5 1988 L 1075.5 1982 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 821.5 1983 L 824.5 1987 L 821.5 1983 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 1384.5 1983 L 1385 1986.5 L 1384 1986.5 L 1384.5 1983 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 829.5 1990 L 830.5 1992 L 829.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 1065.5 1991 L 1064.5 1993 L 1065.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 1383.5 1991 L 1384 1993.5 L 1383 1993.5 L 1383.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 1457.5 1991 L 1458 1994.5 L 1457 1994.5 L 1457.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 833.5 1993 L 834.5 1995 L 833.5 1993 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 1062.5 1993 L 1061.5 1995 L 1062.5 1993 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 1456.5 2000 L 1457 2002.5 L 1456 2002.5 L 1456.5 2000 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 861.5 2005 L 864 2005.5 L 861.5 2006 L 861.5 2005 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 868.5 2006 L 913.5 2006 L 915 2007.5 L 913.5 2007 L 868.5 2007 L 868.5 2006 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 990.5 2006 L 1028 2006.5 L 990.5 2007 L 990.5 2006 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1455.5 2006 L 1456 2008.5 L 1455 2008.5 L 1455.5 2006 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 1010.5 2052 L 1011.5 2054 L 1010.5 2052 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 1357.5 2055 L 1356.5 2057 L 1357.5 2055 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 1354.5 2059 L 1353.5 2061 L 1354.5 2059 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 1016.5 2060 L 1017.5 2062 L 1016.5 2060 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 1349.5 2065 L 1345.5 2070 L 1349.5 2065 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1021.5 2066 L 1034.5 2080 L 1021.5 2066 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 1339.5 2075 L 1335.5 2080 L 1339.5 2075 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 1038.5 2082 L 1039.5 2084 L 1038.5 2082 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 1330.5 2083 L 1329.5 2085 L 1330.5 2083 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 1043.5 2086 L 1044.5 2088 L 1043.5 2086 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 1326.5 2086 L 1325.5 2088 L 1326.5 2086 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 951.5 2096 L 952.5 2098 L 951.5 2096 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 954.5 2100 L 955.5 2102 L 954.5 2100 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 957.5 2104 L 958.5 2106 L 957.5 2104 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 1412.5 2104 L 1411.5 2106 L 1412.5 2104 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 1409.5 2108 L 1407.5 2111 L 1409.5 2108 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 961.5 2109 L 963.5 2112 L 961.5 2109 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 1105.5 2113 L 1108 2113.5 L 1105.5 2114 L 1105.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 1262.5 2113 L 1265 2113.5 L 1262.5 2114 L 1262.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1112.5 2114 L 1116 2114.5 L 1112.5 2115 L 1112.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 1254.5 2114 L 1258 2114.5 L 1254.5 2115 L 1254.5 2114 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 1123.5 2115 L 1248 2115.5 L 1123.5 2116 L 1123.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 1403.5 2115 L 1399.5 2120 L 1403.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 967.5 2116 L 974.5 2124 L 967.5 2116 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 977.5 2126 L 983.5 2133 L 977.5 2126 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 1389.5 2129 L 1385.5 2134 L 1389.5 2129 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 988.5 2136 L 990.5 2139 L 988.5 2136 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1380.5 2137 L 1378.5 2140 L 1380.5 2137 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 994.5 2141 L 995.5 2143 L 994.5 2141 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 1374.5 2142 L 1373.5 2144 L 1374.5 2142 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 1370.5 2145 L 1369.5 2147 L 1370.5 2145 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 1002.5 2147 L 1003.5 2149 L 1002.5 2147 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 1271.5 2186 L 1274 2186.5 L 1271.5 2187 L 1271.5 2186 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 1104.5 2187 L 1107 2187.5 L 1104.5 2188 L 1104.5 2187 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 1263.5 2187 L 1267 2187.5 L 1263.5 2188 L 1263.5 2187 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 1113.5 2188 L 1121 2188.5 L 1113.5 2189 L 1113.5 2188 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 1249.5 2188 L 1257 2188.5 L 1249.5 2189 L 1249.5 2188 Z"
          fill="currentColor"
          fillOpacity="0.3764706"
          stroke="currentColor"
          strokeOpacity="0.3764706"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 217.5 1 L 1022.5 1 L 1023.5 2 L 1035.5 2 L 1075.5 10 Q 1099.5 17 1119.5 28 Q 1156.4 48.1 1183 78.5 Q 1208.3 107.2 1224 145.5 L 1232 169.5 L 1237 192.5 L 1238 207.5 L 1239 208.5 L 1239 228.5 L 1240 229.5 L 1240 1741.5 L 1239 1742.5 L 1239 1763.5 L 1238 1764.5 L 1238 1771.5 L 1237 1772.5 L 1235 1789.5 L 1231 1805.5 L 1220 1835.5 Q 1198.3 1882.3 1161.5 1914 L 1128.5 1938 Q 1113.1 1948.1 1093.5 1954 L 1089 1957.5 Q 1082 1979 1065.5 1991 Q 1053.5 2001 1035.5 2005 Q 1030.7 2003.8 1029.5 2006 L 989 2006 Q 1000.5 2051.1 1031.5 2078 Q 1059.3 2104.2 1103.5 2114 L 1117.5 2115 L 1118.5 2116 L 1251.5 2116 L 1252.5 2115 L 1260.5 2115 L 1271.5 2113 L 1296.5 2105 Q 1327.8 2091.3 1349 2067.5 Q 1364.2 2050.7 1374 2028.5 L 1383 2000.5 L 1385 1989.5 L 1385 1980.5 L 1386 1979.5 L 1386 936.5 L 1392 906.5 L 1404 878.5 Q 1417.8 854.3 1438.5 837 Q 1457 821.5 1481.5 812 L 1507.5 805 L 1524.5 804 L 1525.5 803 L 1537.5 803 L 1538.5 804 L 1549.5 804 L 1565.5 807 L 1591.5 816 Q 1619.6 828.9 1639 850.5 Q 1655.6 868.4 1666 892.5 L 1674 917.5 L 1676 928.5 L 1676 936.5 L 1677 937.5 L 1677 1649.5 L 1679 1660.5 L 1687 1679.5 L 1700.5 1696 Q 1709.8 1704.7 1722.5 1710 L 1742.5 1715 L 1757.5 1715 L 1772.5 1712 L 1782.5 1708 Q 1797.1 1700.6 1807 1688.5 Q 1819.2 1674.7 1823 1652.5 L 1823 839 L 1816.5 839 L 1809.5 837 L 1794 825.5 Q 1744.9 777.1 1723 701.5 L 1716 666.5 L 1715 646.5 L 1714 645.5 L 1714 542.5 Q 1717.5 526 1729.5 518 Q 1736.9 511.6 1750 512 L 1750 437.5 Q 1752.5 436 1751 430.5 Q 1754.9 416.4 1765.5 409 L 1774.5 404 L 1783.5 402 L 1935.5 402 L 1944.5 404 L 1952.5 408 L 1960 414.5 Q 1966.9 422.1 1969 434.5 L 1969 512 Q 1977.3 511 1982.5 514 Q 1991.4 517.6 1997 524.5 Q 2002.9 531.1 2005 541.5 L 2005 648.5 L 2004 649.5 L 2004 659.5 L 2003 660.5 L 2002 674.5 L 1997 698.5 L 1990 721.5 L 1979 748.5 Q 1955.9 796.4 1919.5 831 Q 1911.3 839 1896 839 L 1896 1650.5 L 1895 1651.5 L 1895 1660.5 L 1891 1680.5 L 1880 1708.5 Q 1866.2 1734.7 1844.5 1753 Q 1822.3 1772.3 1790.5 1782 L 1765.5 1787 L 1735.5 1787 L 1706.5 1781 L 1682.5 1771 Q 1659.1 1758.4 1642 1739.5 Q 1627.7 1723.7 1618 1703.5 L 1609 1678.5 L 1605 1656.5 L 1605 944.5 L 1604 943.5 L 1603 931.5 L 1599 919.5 Q 1592.2 904.3 1580.5 894 Q 1568.6 883.4 1551.5 878 L 1541.5 876 L 1521.5 876 Q 1494.5 881 1479 897.5 L 1465 917.5 L 1460 931.5 L 1459 942.5 L 1458 943.5 L 1458 1987.5 L 1457 1988.5 L 1455 2009.5 L 1450 2030.5 L 1438 2062.5 Q 1418.3 2103.3 1386.5 2132 Q 1345.5 2170.5 1280.5 2185 L 1259.5 2187 L 1258.5 2188 L 1111.5 2188 L 1110.5 2187 L 1095.5 2186 L 1076.5 2182 L 1051.5 2174 L 1037.5 2168 Q 998 2149 970 2118.5 Q 944.8 2091.7 929 2055.5 Q 919.1 2033.2 915 2006 L 866.5 2006 L 856.5 2004 Q 831.8 1996.8 818 1978.5 L 813 1970 L 220.5 1970 L 219.5 1969 L 206.5 1969 L 205.5 1968 L 197.5 1968 L 196.5 1967 L 185.5 1966 L 161.5 1960 Q 140.5 1953.5 122.5 1944 Q 84.3 1923.7 57 1892.5 Q 33.2 1865.8 18 1830.5 L 9 1805.5 L 5 1789.5 L 2 1772.5 L 2 1765.5 L 1 1764.5 L 1 1751.5 L 0 1750.5 L 0 220.5 L 1 219.5 L 1 206.5 L 2 205.5 L 3 191.5 L 7 172.5 L 20 135.5 Q 41.7 88.7 78.5 57 Q 105.5 33 141.5 18 L 175.5 7 L 196.5 3 L 216.5 2 L 217.5 1 Z M 212 74 L 186 79 L 169 85 Q 145 95 128 110 Q 108 127 94 150 Q 85 165 79 184 L 73 214 L 74 1520 Q 101 1494 138 1478 Q 158 1469 182 1464 L 199 1462 L 200 1461 L 209 1461 L 210 1460 L 1031 1460 L 1032 1461 L 1053 1463 L 1071 1467 L 1107 1480 L 1133 1494 L 1167 1520 L 1167 217 L 1161 185 L 1154 166 Q 1144 143 1129 127 Q 1112 107 1090 94 L 1058 80 L 1028 74 L 212 74 Z M 1823 475 L 1823 512 L 1896 512 L 1896 475 L 1823 475 Z M 1786 584 L 1787 651 L 1788 652 L 1790 671 L 1794 687 Q 1808 733 1836 765 L 1839 767 L 1881 767 Q 1904 742 1918 708 L 1929 672 L 1931 654 L 1932 653 L 1932 641 L 1933 640 L 1933 584 L 1786 584 Z M 218 1532 L 217 1533 L 208 1533 L 192 1536 L 170 1543 Q 143 1554 124 1572 Q 105 1589 92 1612 Q 83 1627 78 1646 L 73 1672 L 73 1758 L 74 1759 L 75 1772 L 84 1802 Q 94 1825 110 1844 Q 127 1864 151 1877 L 180 1890 L 195 1894 L 213 1896 L 214 1897 L 802 1897 L 802 1640 L 805 1628 L 809 1621 Q 816 1610 831 1606 L 1065 1606 L 1079 1612 L 1089 1624 L 1094 1640 L 1095 1874 L 1114 1860 Q 1133 1843 1147 1820 Q 1156 1803 1162 1784 L 1167 1755 L 1167 1675 L 1166 1674 L 1166 1666 L 1164 1655 Q 1153 1608 1124 1580 Q 1103 1557 1073 1544 L 1049 1536 L 1033 1533 L 1024 1533 L 1023 1532 L 218 1532 Z M 875 1678 L 875 1934 L 1021 1934 L 1021 1678 L 875 1678 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 322.5 220 L 880.5 220 L 890.5 223 L 901 230 L 907 238.5 L 911 249.5 L 911 518.5 Q 907.1 533.1 896.5 541 L 889.5 545 L 877.5 548 L 326.5 548 Q 325 545.5 319.5 547 L 308.5 542 L 300 534.5 L 294 524.5 L 292 516.5 L 292 250.5 Q 295.5 235 306.5 227 Q 312.9 221.9 322.5 220 Z M 364 292 L 364 475 L 839 475 L 839 292 L 364 292 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 401 329 L 474 329 L 474 438 L 401 438 L 401 329 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 511 329 L 583 329 L 583 438 L 511 438 L 511 329 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 620 329 L 693 329 L 693 438 L 620 438 L 620 329 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 504.5 694 L 807.5 694 Q 821.4 696.6 829 705.5 Q 835.2 712.3 838 722.5 L 838 737.5 L 831 752.5 L 732 875.5 L 805.5 876 Q 823.5 879 832 891.5 L 838 905.5 L 838 919.5 L 832 933.5 L 580 1293.5 L 570.5 1305 L 557.5 1312 Q 550.4 1314.4 539.5 1313 Q 526.4 1309.6 519 1300.5 Q 513.1 1293.9 511 1283.5 L 511 1058 L 431.5 1058 Q 416.8 1054.8 409 1044.5 L 402 1030.5 L 401 1019.5 L 475 721.5 Q 478.4 708.9 487.5 702 Q 494.1 696.1 504.5 694 Z M 540 766 L 538 768 L 484 986 L 555 986 L 571 994 Q 580 1002 583 1016 L 583 1161 L 585 1161 L 732 949 L 654 949 L 645 947 L 633 940 Q 622 932 620 917 Q 619 898 628 890 L 726 768 L 726 766 L 540 766 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 174.5 1606 L 408.5 1606 Q 422.4 1609.6 430 1619.5 L 437 1634.5 L 437 1794.5 Q 433.4 1809.4 422.5 1817 L 413.5 1822 L 405.5 1824 L 178.5 1824 Q 162.1 1821.4 154 1810.5 Q 148 1803.5 146 1792.5 L 146 1637.5 Q 149.1 1620.1 161.5 1612 L 174.5 1606 Z M 219 1678 L 219 1751 L 365 1751 L 365 1678 L 219 1678 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 606.5 1606 L 633.5 1606 L 660.5 1613 Q 685.5 1623.5 702 1642.5 Q 718.5 1660.5 726 1687.5 L 729 1704.5 L 729 1724.5 L 724 1748.5 L 714 1770.5 Q 704 1787 689.5 1799 Q 673 1813 649.5 1820 L 627.5 1824 L 612.5 1824 L 590.5 1820 Q 576 1816 564.5 1809 Q 547.2 1798.7 535 1783.5 Q 520.8 1766.7 514 1742.5 L 511 1726.5 L 511 1702.5 Q 518.9 1655.4 549.5 1631 L 574.5 1615 L 591.5 1609 L 606.5 1606 Z M 614 1678 Q 604 1680 598 1685 Q 586 1693 583 1710 Q 582 1728 590 1737 Q 597 1748 613 1751 L 628 1751 L 643 1744 L 653 1732 L 657 1717 Q 657 1699 648 1691 Q 642 1684 634 1680 L 626 1678 L 614 1678 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 83.5 52 L 82.5 54 L 83.5 52 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 1157.5 53 L 1158.5 55 L 1157.5 53 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 76.5 58 L 75.5 60 L 76.5 58 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 1165.5 60 L 1167.5 63 L 1165.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 1178.5 73 L 1180.5 76 L 1178.5 73 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 58.5 76 L 57.5 78 L 58.5 76 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 124.5 113 L 122.5 116 L 124.5 113 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 1119.5 117 L 1123.5 122 L 1119.5 117 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 114.5 123 L 112.5 126 L 114.5 123 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 1130.5 129 L 1131.5 131 L 1130.5 129 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 903.5 534 L 902.5 536 L 903.5 534 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 301.5 536 L 302.5 538 L 301.5 536 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 485.5 703 L 483.5 706 L 485.5 703 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 1936.5 813 L 1935.5 815 L 1936.5 813 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 1784.5 815 L 1785.5 817 L 1784.5 815 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 1436.5 838 L 1435.5 840 L 1436.5 838 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 1633.5 844 L 1635.5 847 L 1633.5 844 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1587.5 902 L 1588.5 904 L 1587.5 902 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 410.5 1046 L 412.5 1049 L 410.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 80.5 1513 L 79.5 1515 L 80.5 1513 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 1161.5 1515 L 1162.5 1517 L 1161.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 1113.5 1570 L 1114.5 1572 L 1113.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 1127.5 1584 L 1128.5 1586 L 1127.5 1584 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 110.5 1586 L 109.5 1588 L 110.5 1586 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 425.5 1614 L 428.5 1618 L 425.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 547.5 1632 L 546.5 1634 L 547.5 1632 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 694.5 1634 L 700.5 1641 L 694.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 538.5 1641 L 537.5 1643 L 538.5 1641 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 594.5 1688 L 593.5 1690 L 594.5 1688 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 1803.5 1691 L 1799.5 1696 L 1803.5 1691 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 1637.5 1734 L 1638.5 1736 L 1637.5 1734 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 591.5 1737 L 592.5 1739 L 591.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 1859.5 1738 L 1858.5 1740 L 1859.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 646.5 1739 L 644.5 1742 L 646.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 1645.5 1743 L 1648.5 1747 L 1645.5 1743 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 1847.5 1750 L 1846.5 1752 L 1847.5 1750 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 1656.5 1753 L 1657.5 1755 L 1656.5 1753 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 702.5 1786 L 701.5 1788 L 702.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 692.5 1796 L 691.5 1798 L 692.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 155.5 1812 L 157.5 1815 L 155.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 114.5 1847 L 122.5 1856 L 114.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 1125.5 1847 L 1117.5 1856 L 1125.5 1847 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 1188.5 1886 L 1187.5 1888 L 1188.5 1886 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 52.5 1887 L 53.5 1889 L 52.5 1887 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 1182.5 1893 L 1181.5 1895 L 1182.5 1893 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 59.5 1895 L 60.5 1897 L 59.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 73.5 1909 L 74.5 1911 L 73.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 1164.5 1911 L 1163.5 1913 L 1164.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 81.5 1916 L 82.5 1918 L 81.5 1916 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 1157.5 1917 L 1156.5 1919 L 1157.5 1917 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 818.5 1979 L 819.5 1981 L 818.5 1979 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 1351.5 2063 L 1350.5 2065 L 1351.5 2063 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 1019.5 2064 L 1020.5 2066 L 1019.5 2064 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 1334.5 2080 L 1333.5 2082 L 1334.5 2080 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 1398.5 2120 L 1390.5 2129 L 1398.5 2120 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 975.5 2124 L 976.5 2126 L 975.5 2124 Z"
          fill="currentColor"
          fillOpacity="0.7372549"
          stroke="currentColor"
          strokeOpacity="0.7372549"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 212.5 1 L 216 1.5 L 212.5 2 L 212.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 1024.5 1 L 1027 1.5 L 1024.5 2 L 1024.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 74.5 60 L 72.5 63 L 74.5 60 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 1168.5 63 L 1177.5 73 L 1168.5 63 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 62.5 72 L 59.5 76 L 62.5 72 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 1116.5 114 L 1118.5 117 L 1116.5 114 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 1124.5 122 L 1126.5 125 L 1124.5 122 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 73.5 213 L 74 215.5 L 73 215.5 L 73.5 213 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 0.5 215 L 1 218.5 L 0 218.5 L 0.5 215 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 1166.5 216 L 1167 218.5 L 1166 218.5 L 1166.5 216 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1239.5 219 L 1240 227.5 L 1239 227.5 L 1239.5 219 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 304.5 228 L 300.5 233 L 304.5 228 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 911.5 254 L 912 512.5 L 911 512.5 L 911.5 254 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 365.5 292 L 838 292.5 L 365 293 L 364.5 475 L 364 293.5 L 365.5 292 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 510.5 329 L 511 437.5 L 510 437.5 L 510.5 329 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 1750.5 434 L 1751 436.5 L 1750 436.5 L 1750.5 434 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 1823.5 511 L 1896 511.5 L 1823.5 512 L 1823.5 511 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 901.5 536 L 899.5 539 L 901.5 536 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 1786.5 585 L 1787 634.5 L 1786 634.5 L 1786.5 585 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 1932.5 633 L 1933 639.5 L 1932 639.5 L 1932.5 633 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 1714.5 646 L 1715 649.5 L 1714 649.5 L 1714.5 646 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 2004.5 650 L 2005 652.5 L 2004 652.5 L 2004.5 650 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 838.5 727 L 839 732.5 L 838 732.5 L 838.5 727 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1881.5 765 L 1880.5 767 L 1881.5 765 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 539.5 766 L 726 766.5 L 539.5 767 L 539.5 766 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 1521.5 803 L 1525 803.5 L 1521.5 804 L 1521.5 803 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 1538.5 803 L 1542 803.5 L 1538.5 804 L 1538.5 803 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 1934.5 815 L 1933.5 817 L 1934.5 815 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 1786.5 817 L 1787.5 819 L 1786.5 817 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 1625.5 837 L 1626.5 839 L 1625.5 837 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 1434.5 840 L 1433.5 842 L 1434.5 840 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 1424.5 850 L 1422.5 853 L 1424.5 850 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 825.5 884 L 826.5 886 L 825.5 884 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 829.5 888 L 830.5 890 L 829.5 888 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 838.5 909 L 839 915.5 L 838 915.5 L 838.5 909 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 1458.5 944 L 1459 1972.5 L 1458 1972.5 L 1458.5 944 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 1604.5 945 L 1605 1646.5 L 1604 1646.5 L 1604.5 945 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 485.5 985 L 549 985.5 L 485.5 986 L 485.5 985 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 545.5 1313 L 549 1313.5 L 545.5 1314 L 545.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 222.5 1459 L 1018 1459.5 L 222.5 1460 L 222.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 78.5 1515 L 77.5 1517 L 78.5 1515 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 1163.5 1517 L 1164.5 1519 L 1163.5 1517 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 217.5 1532 L 221 1532.5 L 217.5 1533 L 217.5 1532 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 1018.5 1532 L 1022 1532.5 L 1018.5 1533 L 1018.5 1532 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 129.5 1567 L 128.5 1569 L 129.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 120.5 1575 L 115.5 1581 L 120.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 179.5 1605 L 405 1605.5 L 179.5 1606 L 179.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 613.5 1605 L 627 1605.5 L 613.5 1606 L 613.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 835.5 1605 L 1061 1605.5 L 835.5 1606 L 835.5 1605 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 814.5 1614 L 811.5 1618 L 814.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 1081.5 1614 L 1084.5 1618 L 1081.5 1614 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 688.5 1629 L 689.5 1631 L 688.5 1629 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 545.5 1634 L 539.5 1641 L 545.5 1634 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 437.5 1640 L 438 1788.5 L 437 1788.5 L 437.5 1640 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 1677.5 1647 L 1678 1649.5 L 1677 1649.5 L 1677.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 1166.5 1675 L 1167 1677.5 L 1166 1677.5 L 1166.5 1675 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 596.5 1686 L 595.5 1688 L 596.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 1805.5 1689 L 1804.5 1691 L 1805.5 1689 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 656.5 1712 L 657 1716.5 L 656 1716.5 L 656.5 1712 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 510.5 1713 L 511 1715.5 L 510 1715.5 L 510.5 1713 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 1755.5 1714 L 1758 1714.5 L 1755.5 1715 L 1755.5 1714 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 648.5 1737 L 647.5 1739 L 648.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 1857.5 1740 L 1848.5 1750 L 1857.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 1239.5 1742 L 1240 1752.5 L 1239 1752.5 L 1239.5 1742 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 0.5 1752 L 1 1755.5 L 0 1755.5 L 0.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 1166.5 1752 L 1167 1754.5 L 1166 1754.5 L 1166.5 1752 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 1842.5 1754 L 1841.5 1756 L 1842.5 1754 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 73.5 1755 L 74 1757.5 L 73 1757.5 L 73.5 1755 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 537.5 1786 L 538.5 1788 L 537.5 1786 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 1745.5 1787 L 1755 1787.5 L 1745.5 1788 L 1745.5 1787 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 700.5 1788 L 693.5 1796 L 700.5 1788 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 547.5 1796 L 548.5 1798 L 547.5 1796 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 428.5 1811 L 427.5 1813 L 428.5 1811 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 425.5 1814 L 424.5 1816 L 425.5 1814 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 609.5 1823 L 612 1823.5 L 609.5 1824 L 609.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 628.5 1823 L 631 1823.5 L 628.5 1824 L 628.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 112.5 1845 L 113.5 1847 L 112.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1127.5 1845 L 1126.5 1847 L 1127.5 1845 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 123.5 1856 L 124.5 1858 L 123.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 1116.5 1856 L 1115.5 1858 L 1116.5 1856 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 1180.5 1895 L 1178.5 1898 L 1180.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 213.5 1896 L 216 1896.5 L 213.5 1897 L 213.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 61.5 1897 L 72.5 1909 L 61.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 1167.5 1908 L 1165.5 1911 L 1167.5 1908 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 875.5 1933 L 1021 1933.5 L 875.5 1934 L 875.5 1933 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 215.5 1969 L 220 1969.5 L 215.5 1970 L 215.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 1385.5 1975 L 1386 1979.5 L 1385 1979.5 L 1385.5 1975 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 826.5 1987 L 827.5 1989 L 826.5 1987 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1068.5 1988 L 1067.5 1990 L 1068.5 1988 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 1457.5 1988 L 1458 1990.5 L 1457 1990.5 L 1457.5 1988 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 1345.5 2070 L 1340.5 2076 L 1345.5 2070 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 1410.5 2106 L 1409.5 2108 L 1410.5 2106 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 1405.5 2112 L 1404.5 2114 L 1405.5 2112 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 965.5 2113 L 966.5 2115 L 965.5 2113 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 1119.5 2115 L 1122 2115.5 L 1119.5 2116 L 1119.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 1248.5 2115 L 1251 2115.5 L 1248.5 2116 L 1248.5 2115 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 985.5 2133 L 986.5 2135 L 985.5 2133 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 1383.5 2134 L 1382.5 2136 L 1383.5 2134 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 1122.5 2188 L 1248 2188.5 L 1122.5 2189 L 1122.5 2188 Z"
          fill="currentColor"
          fillOpacity="0.7490196"
          stroke="currentColor"
          strokeOpacity="0.7490196"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'ChargerTwo')

export default icon
